<ol class="timeline" *ngIf="entries.length; else empty">
	<li
		class="entry"
		*ngFor="let entry of entries; trackBy: trackByEntry"
		[style.--status-color]="PromiseToPayStatus.getColor(entry.status)"
	>
		<span class="dot" aria-hidden="true"></span>

		<div class="body">
			<div class="line-1">
				<span class="status">{{ entry.status ?? 'Edited' }}</span>
				<span class="at">{{ formatAt(entry.at) }}</span>
			</div>

			<ul class="changes" *ngIf="entry.changes">
				<li *ngFor="let line of changeLines(entry)">
					<span class="change-label">{{ line.label }}</span>
					{{ line.from }} → {{ line.to }}
				</li>
			</ul>

			<div class="line-2">
				<span class="actor" [class.system]="!entry.byName">{{
					actorLabel(entry)
				}}</span>
			</div>
		</div>
	</li>
</ol>

<ng-template #empty>
	<p class="timeline-empty">No history recorded.</p>
</ng-template>
